import axios from 'axios';
import {mapStackTrace} from 'sourcemapped-stacktrace';

const axiosClient = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/rest`,
  withCredentials: true
});

export async function reportApiError({url, message, stack, ...report}) {
  try {
    if (stack) {
      const mapped = await new Promise((resolve) => mapStackTrace(stack, (frames) => resolve(frames.join('\n'))));
      if (mapped) {
        stack = mapped;
      }
    }
  } catch (e) {
    console.log('Error getting stack trace', e);
  }

  try {
    await axiosClient({
      url: `${process.env.REACT_APP_BASE_URL}/rest/errors/api`,
      method: 'POST',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: {error: {...report, url, message, stack}},
    });
  } catch (e) {
    console.log('Error reporting error', e);
  }
}
